// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"d5b93b93","297":"f0add762","643":"1b18d25f","959":"d56c3477"}[chunkId] + ".chunk.js";
};